import React from 'react'
import DeactivateBudget from 'src/app/DeactivateBudget/DeactivateBudget'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { deactivateBudgetRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const DeactivateBudgetAppRoute: AppRoute = {
  id: AppLocation.DeactivateBudget,
  routeProps: deactivateBudgetRouteProps,
  component: <DeactivateBudget />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default DeactivateBudgetAppRoute
